import { render, staticRenderFns } from "./balance-trans-detail.vue?vue&type=template&id=1f116d74&scoped=true"
import script from "./balance-trans-detail.vue?vue&type=script&lang=js"
export * from "./balance-trans-detail.vue?vue&type=script&lang=js"
import style0 from "./balance-trans-detail.vue?vue&type=style&index=0&id=1f116d74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f116d74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f116d74')) {
      api.createRecord('1f116d74', component.options)
    } else {
      api.reload('1f116d74', component.options)
    }
    module.hot.accept("./balance-trans-detail.vue?vue&type=template&id=1f116d74&scoped=true", function () {
      api.rerender('1f116d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data/balance-trans-detail.vue"
export default component.exports